import { useMemo } from "react";
import { useOctraceClient } from "@/contexts/ApiClientContext";
import { isAdmin as checkIsAdmin } from "@/utils/permissions";
import { useQuery } from "@tanstack/react-query";

export const userQueryKey = ["user", "get"];

const useUser = () => {
  const { apiClient } = useOctraceClient();

  const query = useQuery({
    queryKey: userQueryKey,
    queryFn: () => apiClient.users.get(),
  });

  const isAdmin = useMemo(() => checkIsAdmin(query.data), [query.data]);

  return {
    data: query.data,
    isLoading: query.isLoading,
    isError: query.isError,
    isAdmin,
  };
};

export default useUser;
